import React from 'react';
import { Link } from '@mui/material';
import { ExpenseClaimService } from '../../services/expense-claim.service';
import { useToast } from '../../context/ToastContext';
import { saveBlob } from '../../utils/saveBlob';

/** Receipt cell for the claim view and approval screens: a link that downloads the file, or a dash. */
const ExpenseReceiptLink: React.FC<{ claimId: string; receiptId?: string | null }> = ({ claimId, receiptId }) => {
    const toast = useToast();
    if (!receiptId) return <>—</>;
    const open = async () => {
        try {
            const { blob, fileName } = await ExpenseClaimService.downloadReceipt(claimId, receiptId);
            saveBlob(blob, fileName);
        } catch {
            toast.showError('Could not open the receipt');
        }
    };
    return (
        <Link component="button" type="button" variant="body2" onClick={open}
            data-help="expense.claimLines.receipt.open" aria-label="Open receipt">
            ✓ Open
        </Link>
    );
};

export default ExpenseReceiptLink;
